import Api from '../api';

const addressEndpoint = '/address';

type GetAddressSuggestionsParams = {
  search: string;
  country: string;
};

type GetAddressByPlaceIdParams = {
  placeId: string;
};

type ValidateAddressParams = {
  address: string;
  country: string;
};

const AddressAPI = {
  async getAddressSuggestions({
    search,
    country,
  }: GetAddressSuggestionsParams) {
    const url = `${addressEndpoint}/suggestions?search=${search}&country=${country}`;
    return Api.get(url);
  },

  async getAddressByPlaceId({ placeId }: GetAddressByPlaceIdParams) {
    const url = `${addressEndpoint}/place/${placeId}`;
    return Api.get(url);
  },

  async validateAddress({ address, country }: ValidateAddressParams) {
    const url = `${addressEndpoint}/validate?address=${address}&country=${country}`;
    return Api.get(url);
  },
};

export default AddressAPI;
